import { DEFAULT_DECIMAL_SEPARATOR } from '../../constants/defaultDecimalSeparator'
import { LocaleSeparators } from '../../types/LocaleSeparators'
import { isDigitCharCode } from './isDigitCharCode'

/**
 * Converts a string into a number based on provided separators.
 */
export const convertToNumber = (input: string, separators: LocaleSeparators): number => {
  let numericString = input[0] === '-' ? '-' : ''

  // filter out everything except digits and decimal separator
  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i)

    if (isDigitCharCode(charCode)) {
      numericString += input[i]
    } else if (input[i] === separators.decimalSeparator) {
      numericString += DEFAULT_DECIMAL_SEPARATOR
    }
  }

  const finalValue = Number(numericString)
  return isNaN(finalValue) ? 0 : finalValue
}
